import * as React from "react";
import {none, Option} from "ts-option";
import {FocusableProps} from "../../common/props/FocusableProps";
import {PressableProps} from "../../common/props/PresableProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import SelectLeadCategory from "../category/select/SelectLeadCategory";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";


type Props = FormGroupProps<string[]> & FocusableProps & PressableProps;

/**
 * Lead category form view group.
 */
export default class LeadCategoryFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectLeadCategory
					selectedId={this.props.field.getOptionalValue()}
					onChanged={this.onChange}
					multi
				/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed category.
	 * @param categories
	 */
	onChange(categories: Option<DictionaryItem[]>) {
		this.props.onChange(this.props.field.updateValue(
			categories.isDefined && categories.get.length > 0 ? categories.map(tab => tab.map(lc => lc.id)) : none));
	}
}
